// ** React Imports
import { Suspense, lazy } from 'react'
import ReactDOM from 'react-dom'

// ** Redux Imports
import { Provider } from 'react-redux'
import { store } from './redux/storeConfig/store'

// ** Intl, CASL & ThemeColors Context
import ability from './configs/acl/ability'
import { ToastContainer } from 'react-toastify'
import { AbilityContext } from './utility/context/Can'
import { ThemeContext as ThemeColorsContext } from './utility/context/ThemeColors'
import { ThemeProvider } from './utility/context/ThemeContext'
import { IntlProviderWrapper } from './utility/context/Internationalization'
import { PaymentLinkProvider } from './utility/context/PaymentLink'

// ** Spinner (Splash Screen)
import Spinner from './@core/components/spinner/Fallback-spinner'

// ** Ripple Button
import './@core/components/ripple-button'

// ** PrismJS
import 'prismjs'
import 'prismjs/themes/prism-tomorrow.css'
import 'prismjs/components/prism-jsx.min'

// ** React Perfect Scrollbar
import 'react-perfect-scrollbar/dist/css/styles.css'

// ** React Toastify
import '@styles/react/libs/toastify/toastify.scss'

// ** Core styles
import './@core/assets/fonts/feather/iconfont.css'
import './@core/scss/core.scss'
import './assets/scss/style.scss'

// ** Service Worker
import * as serviceWorker from './serviceWorker'

// ** Aplica a marca (title, body class, theme-color, favicon, manifest) em
// runtime, baseado em window.location.hostname. Ver site/src/configs/brand.js.
import applyBrandToDocument from './configs/applyBrandToDocument'
applyBrandToDocument()

// ** Lazy load app
const LazyApp = lazy(() => import('./App'))

ReactDOM.render(
  <Provider store={store}>
    <ThemeProvider>
      <Suspense fallback={<Spinner />}>
        <AbilityContext.Provider value={ability}>
          <ThemeColorsContext>
            <IntlProviderWrapper>
              <PaymentLinkProvider>
                <LazyApp />
                <ToastContainer newestOnTop />
              </PaymentLinkProvider>
            </IntlProviderWrapper>
          </ThemeColorsContext>
        </AbilityContext.Provider>
      </Suspense>
    </ThemeProvider>
  </Provider>,
  document.getElementById('root')
)

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister()
